import React, { useEffect, useState } from "react";
import SearchBar from "./SearchBar";
import { Link } from "react-router-dom";
import axios from "axios";
import Loading from "./Loading";
// create the form data from FE and send to server
// in routes use multer as middleware then send data to cloudinary
// get response and now create the recipe

const Home = () => {
  const noImg =
    "https://www.shutterstock.com/image-vector/empty-placeholder-image-icon-design-260nw-1366372628.jpg";
  const [recipeData, setRecipeData] = useState([]);
  const getData = () => {
    axios
      .get("https://the-menu-server-a0c079ab1940.herokuapp.com/api/recipes")
      .then((res) => setRecipeData(res.data.reverse()));
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      <div className="home-cnt">
        <SearchBar props={recipeData} />
        {recipeData[0] ? (
          <div className="grid">
            {recipeData[0] &&
              recipeData.map((item, index) => (
                <Link
                  style={{ textDecoration: "none" }}
                  to={"/recipeDetails/" + item._id}
                  key={index}
                  className="card"
                >
                  <img src={item.image.url ? item.image.url : noImg} alt="" />
                  <div className="layer">{item.title}</div>
                </Link>
              ))}
          </div>
        ) : (
          <Loading />
        )}
      </div>
    </div>
  );
};

export default Home;
